<template>
  <div style="height: 100%">
    <div style="width: 200px; position: absolute; z-index: 20">
      <Float_menu />
    </div>
    <div class="body-container">
      <div class="row1 col-edge">
        <welcome_page_title />
      </div>
      <div class="row2 col-edge">
        <el-col :span="8">
          <el-row class="row21 col-edge">
            <!-- <dv-border-box-12> -->
            <el-col :span="24" class="col1"
              ><div class="alltitle">CPU使用 TOP5</div>
              <CPU_utilization_top10
            /></el-col>
            <div class="col-foot"></div>
            <!-- </dv-border-box-12> -->
          </el-row>

          <el-row class="row21 col-edge">
            <el-col :span="24" class="col1"
              ><div class="alltitle">网络流量 TOP5</div>
              <networkTraffic_top10
            /></el-col>
            <div class="col-foot"></div>
          </el-row>
          <el-row class="row21 col-edge">
            <el-col :span="24" class="col1"
              ><div class="alltitle">内存占用 TOP5</div>
              <MEM_utilization_top10
            /></el-col>
            <div class="col-foot"></div>
          </el-row>
          <!-- <el-row class="row21 col-edge">
          <el-col :span="24" class="col1"
            ><div class="alltitle">磁盘利用率 TOP5</div>
            <space_utilization_top10
          /></el-col>
          <div class="col-foot"></div>
        </el-row> -->
        </el-col>
        <el-col :span="16">
          <el-row class="row31 col-edge">
            <el-col :span="24" class="col1"
              ><div class="alltitle"></div>
              <all_DC_info_small
            /></el-col>
            <div class="col-foot"></div
          ></el-row>
          <el-row class="row32 col-edge">
            <el-col :span="24" class="col1"
              ><div class="alltitle"></div>
              <problemReport
            /></el-col>
            <div class="col-foot"></div
          ></el-row>
        </el-col>
      </div>
    </div>
  </div>
</template>

<script>
import { Url } from "../config/env";

import welcome_page_title from "../views/welcome_page_title";
import networkTraffic_top10 from "../views/networkTraffic_top10";
import CPU_utilization_top10 from "../views/CPU_utilization_top10";
import MEM_utilization_top10 from "../views/MEM_utilization_top10";
import space_utilization_top10 from "../views/space_utilization_top10";
import all_DC_info_small from "../views/all_DC_info_small";
import problemReport from "../views/problemReport";
import Float_menu from "../views/Float_menu";

export default {
  data() {
    return {
      mychartOptions: {},
      baseUrl: Url,
      // backgroud_png: Url + "/topo_data/all_DC_info_small/all_dc_bg.png",
      envData: {
        colors: {
          status_colors: ["#004495", "orange", "#DC251F"],
          border_colors: ["grey", "orange"],
        },
      },
    };
  },
  name: "Welcome_page",
  components: {
    welcome_page_title,
    networkTraffic_top10,
    CPU_utilization_top10,
    MEM_utilization_top10,
    space_utilization_top10,
    all_DC_info_small,
    problemReport,
    Float_menu,
  },
};
</script>

<style lang="less">
.body-container {
  background-size: 100% 100%;
  height: 100%;
  // animation: bg_rorate 1s linear infinite;
}
// .el-header,
// .el-footer {
//   background-color: #b3c0d1;
//   // color: #333;
//   text-align: center;
//   height: 160px;
// }
.row1 {
  width: 100%;
  height: 15%;
  margin: 2px;
}
.row2 {
  width: 100%;
  height: 84%;
  margin: 2px;
  display: flex;
}
.row21 {
  height: 32%;
  margin-bottom: 17px;
  margin-left: 17px;
  margin-right: 17px;
}
.row31 {
  height: 66%;
  margin-bottom: 7px;
  margin-left: 7px;
  margin-right: 7px;
}
.row32 {
  height: 33%;
  margin-bottom: 7px;
  margin-left: 7px;
  margin-right: 7px;
}
.col-foot:before {
  // border-left: 2px solid #02a6b5;
  left: 0;
}
.col-edge:after,
.col-foot:after {
  // border-right: 2px solid #02a6b5;
  right: 0;
}
.col-foot {
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
}
.col-foot:before,
.col-foot:after {
  position: absolute;
  width: 0.5rem;
  height: 0.5rem;
  bottom: 0;
}
.col-edge {
  z-index: 10;
}
.col1 {
  height: 100%;
}
.alltitle {
  font-size: 18px;
  color: #4d99fc;
  // font-weight: bold;
  position: relative;
  padding-left: 12px;
  margin-bottom: 5px;
}
</style>
